import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    Client,
    CreateClientInput,
    DeleteClientInput,
    UpdateClientInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ClientService {
    private amplifyClient = generateClient();

    constructor() {}

    async listClients(): Promise<Client[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listClients
                })
            ).data.listClients.items;
            if (data) return data as Client[];
        } catch (error) {
            console.error('Error finding Clients:', error);
            return null;
        }
    }

    async getClient(id: string): Promise<Client> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getClient,
                    variables: {
                        id
                    }
                })
            ).data.getClient;
            if (data) return data as Client;
        } catch (error) {
            console.error('Error finding Clients:', error);
            return null;
        }
    }

    async createClient(input: CreateClientInput): Promise<Client> {
        try {
            const client = (
                await this.amplifyClient.graphql({
                    query: mutations.createClient,
                    variables: {
                        input
                    }
                })
            ).data.createClient;
            if (client) return client as Client;
        } catch (error) {
            console.error('Error creating client:', error);
            return null;
        }
    }

    async updateClient(input: UpdateClientInput): Promise<Client> {
        try {
            const client = (
                await this.amplifyClient.graphql({
                    query: mutations.updateClient,
                    variables: {
                        input
                    }
                })
            ).data.updateClient;
            if (client) return client as Client;
        } catch (error) {
            console.error('Error updating client:', error);
            return null;
        }
    }

    async deleteClient(input: DeleteClientInput): Promise<Client> {
        try {
            const deleteClient = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteClient,
                    variables: {
                        input
                    }
                })
            ).data.deleteClient;
            return deleteClient as Client;
        } catch {
            console.error('Error deleted client:', Error);
            return null;
        }
    }
}
